import React, { useState } from 'react'
import AppLayout from '../../layout/components/AppLayout'
import ComplaintFormComponent from '../components/ComplaintFormComponent'
import RequestPhoneNo from '../components/common/RequestPhoneNo'

function ComplainFormPage() {

  const [customerPhoneStatus,setCustomerPhoneStatus] = useState(false);


  const updateCustomerPhone = (customerPhone) =>{
		if(customerPhone){
      setCustomerPhoneStatus(true)
    }
  }

  return (
    <AppLayout>
        <div className='container'>
            {customerPhoneStatus ?
              <ComplaintFormComponent/>
              :
              <div className='text-center'>
                <h3>You need To verify your phone Number to Continue</h3>
              </div>
            }
            
        </div>
          
            <RequestPhoneNo requestStatus={true} callback={updateCustomerPhone} canSkip={false} />
          
    </AppLayout>
  )
}

export default ComplainFormPage